import { Helmet } from "react-helmet";
import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <Helmet>
        <title>Page Not Found | SpotlightAdz</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you're looking for doesn't exist. Return to SpotlightAdz homepage or browse our blog." />
      </Helmet>
      
      <div className="text-center max-w-lg mx-auto px-4">
        <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-muted-foreground mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button onClick={() => navigate("/")} className="gap-2">
            <Home className="h-4 w-4" />
            Go to Homepage
          </Button>
          <Button variant="outline" onClick={() => navigate("/blog")} className="gap-2">
            <Search className="h-4 w-4" />
            Browse Blog
          </Button>
        </div>

        <nav className="mt-12 text-sm text-muted-foreground" aria-label="Helpful links">
          <p className="mb-3">You might be looking for:</p>
          <ul className="space-y-2">
            <li><Link to="/" className="text-primary hover:underline">SpotlightAdz Homepage</Link></li>
            <li><Link to="/blog" className="text-primary hover:underline">Marketing Blog</Link></li>
            <li><Link to="/client-login" className="text-primary hover:underline">Client Portal Login</Link></li>
            <li><a href="https://spotlightadz.ma/#services" className="text-primary hover:underline">Our Services</a></li>
            <li><a href="https://spotlightadz.ma/#request" className="text-primary hover:underline">Request a Service</a></li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default NotFound;